import { SET_CARTS, SET_CART } from '../actionsList';

const initialCarts = {
    list: [],
    applets: {},
    hubs: {},
    count: 0
};

const cartsReducer = (state = initialCarts, action) => {
    switch (action.type) {
        case SET_CARTS: {

            let carts = action.carts ?? []
            let list = state.list ?? []
            let finalList = list
            let applets = {}
            let hubs = {}

            carts.forEach(oneOfCarts => {

                let found = false

                list.forEach(oneOfList => {
                    if (oneOfList._id == oneOfCarts._id) {
                        found = true
                    }
                });

                if (!found) {
                    finalList.push(oneOfCarts)
                }
            });


            finalList.forEach((cart, index) => {
                let appletId = typeof cart.applet == 'object' ? cart.applet._id : cart.applet
                let hubId = typeof cart.appletHub == 'object' ? cart.appletHub._id : cart.appletHub

                applets[appletId] = cart

                if (!hubs[hubId]) {
                    hubs[hubId] = {}
                }
                hubs[hubId][appletId] = cart


            })

            // console.log(carts, applets, hubs)


            return {
                ...state,
                list: finalList,
                applets,
                hubs
            }
        }


        case SET_CART: {

            let list = state.list
            let applets = {}
            let hubs = {}

            let foundIndex

            list.forEach((cart, index) => {
                let appletId = typeof action.cart?.applet == 'object' ? action.cart?.applet?._id : action.cart?.applet
                if (cart?.applet?._id == appletId) {
                    foundIndex = index
                }
            })

            if (foundIndex != null) {
                list[foundIndex] = action.cart
            } else {
                list.push(action.cart)
            }

            list.forEach((cart, index) => {
                let appletId = typeof cart.applet == 'object' ? cart.applet?._id : cart.applet
                let hubId = typeof cart.appletHub == 'object' ? cart.appletHub?._id : cart.appletHub

                applets[appletId] = cart

                if (!hubs[hubId]) {
                    hubs[hubId] = {}
                }
                hubs[hubId][appletId] = cart
            })

            // console.log("List", list)



            return {
                ...state,
                list: list,
                applets,
                hubs
            }
        }


        default:
            return state;
    }
}

export default cartsReducer;